<div ngbDropdown #calendarPanel="ngbDropdown" autoClose="outside">
  <label attr.for="{{id}}">{{title}}</label>
  <div class="input-group">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        [id]="id" name="data"
        [(ngModel)]="dataTxt"
        [placeholder]="mask"
        #item
        (input)="change(item.value)"
        (focusout)="onFocusOut($event.target.value)"
        [ngClass]="{'is-invalid': isInvalid}">
      <div class="input-group-append">
        <button type="button" class="input-group-text" ngbDropdownToggle aria-label="Open month picker">
          <i class="fas fa-calendar"></i>
        </button>
      </div>
    </div>
  </div>
  <div ngbDropdownMenu class="dropdown-menu" >
    <div class="row">
      <span class="btn btn-link col-4" (click)="addYear($event,-1)">
        <span class="ngb-dp-navigation-arrow left"></span>
      </span>
      <button *ngIf="!isyear" class="btn btn-link col-4" (click)="showYear($event,true)">{{data.year || 2019}}</button>
      <button *ngIf="isyear" class="btn btn-link col-4" (click)="showYear($event,false)">{{incr+1}}-{{incr+10}}</button>
      <span class="btn btn-link col-4" (click)="addYear($event,+1)">
        <span class="ngb-dp-navigation-arrow right"></span>
      </span>
      <div *ngFor="let month of months; let i = index; let first = first; let last = last" class="col-4" (click)="selectYearMonth($event,i)">
        <div [ngClass]="{'select': !isyear?(i+1)==data.month:(i+incr)==data.year,'outrange':isyear && (first || last)}" class="card-body">
          <span ngbDropdownToggle *ngIf="!isyear">{{month}}</span>
          <span *ngIf="isyear">{{i+incr}}</span>
        </div>
      </div>
    </div>
  </div>
</div>

